module.exports = __webpack_public_path__ + "img/logo_podo_row_white.026bad9c.png";